import React, { useEffect, useRef, useState } from 'react';

// 3D 에셋 뷰어 — Google <model-viewer>로 glb 파일을 보여준다 (마우스로 회전·확대).
// url: 파일 주소(서버 URL 또는 blob URL)
// [당첨 축하 팝업] 선택 prop 추가 — 기본값은 기존 동작과 같음
// autoRotate: 자동 회전, backgroundColor: 뷰어 배경, loadingContent: 로딩 표시 대체, onError: 라이브러리·파일 로드 실패 시 호출
// [당첨 축하 팝업 미리 받기] hideLoading: 로딩 표시 숨김, onLoad: 3D 로드 완료 시 호출
// const ModelViewer = ({ url }) => {
// [당첨 축하 팝업 표시 시점] onVisible: 모델이 화면에 실제로 보이게 된 시점(model-visibility, detail.visible === true)에 호출
// const ModelViewer = ({ url, autoRotate = false, backgroundColor = '#f3f4f6', loadingContent = null, onError }) => {
// const ModelViewer = ({ url, autoRotate = false, backgroundColor = '#f3f4f6', loadingContent = null, hideLoading = false, onLoad, onError }) => {
const ModelViewer = ({ url, autoRotate = false, backgroundColor = '#f3f4f6', loadingContent = null, hideLoading = false, onLoad, onVisible, onError }) => {
  const viewerRef = useRef(null);
  const [isLibReady, setIsLibReady] = useState(false);
  const [status, setStatus] = useState('loading'); // loading | ready | error
  // 리스너 재등록 없이 최신 onError를 호출하기 위해 ref로 보관
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  // [당첨 축하 팝업 미리 받기] 최신 onLoad도 ref로 보관
  const onLoadRef = useRef(onLoad);
  onLoadRef.current = onLoad;
  // [당첨 축하 팝업 표시 시점] 최신 onVisible도 ref로 보관
  const onVisibleRef = useRef(onVisible);
  onVisibleRef.current = onVisible;

  // 뷰어를 처음 열 때만 라이브러리를 불러온다 (three.js가 포함된 단일 번들)
  useEffect(() => {
    let cancelled = false;
    import('@google/model-viewer/dist/model-viewer.min.js')
      .then(() => {
        if (!cancelled) setIsLibReady(true);
      })
      .catch(error => {
        console.error('model-viewer 로드 실패:', error);
        // if (!cancelled) setStatus('error');
        if (!cancelled) {
          setStatus('error');
          if (onErrorRef.current) onErrorRef.current(error);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const viewer = viewerRef.current;
    if (!isLibReady || !viewer) return undefined;

    setStatus('loading');
    // const handleLoad = () => setStatus('ready');
    const handleLoad = () => {
      setStatus('ready');
      if (onLoadRef.current) onLoadRef.current();
    };
    const handleError = event => {
      console.error('3D 에셋 로드 실패:', event?.detail);
      setStatus('error');
      if (onErrorRef.current) onErrorRef.current(event);
    };
    // [당첨 축하 팝업 표시 시점] model-viewer 4.1.0 model-visibility 이벤트 (src/model-viewer-base.ts:203-210)
    const handleVisibility = event => {
      if (event?.detail?.visible === true && onVisibleRef.current) onVisibleRef.current();
    };
    viewer.addEventListener('load', handleLoad);
    viewer.addEventListener('error', handleError);
    viewer.addEventListener('model-visibility', handleVisibility);
    return () => {
      viewer.removeEventListener('load', handleLoad);
      viewer.removeEventListener('error', handleError);
      viewer.removeEventListener('model-visibility', handleVisibility);
    };
  }, [isLibReady, url]);

  return (
    <div className="relative w-full h-full">
      {isLibReady && (
        <model-viewer
          ref={viewerRef}
          src={url}
          alt="3D 에셋"
          camera-controls=""
          auto-rotate={autoRotate ? '' : undefined}
          touch-action="pan-y"
          shadow-intensity="1"
          // style={{ width: '100%', height: '100%', backgroundColor: '#f3f4f6' }}
          style={{ width: '100%', height: '100%', backgroundColor }}
        ></model-viewer>
      )}
      {/* {status === 'loading' && ( */}
      {/* [당첨 축하 팝업 미리 받기] hideLoading이면 로딩 표시 없음 */}
      {/* {status === 'loading' && loadingContent} */}
      {/* {status === 'loading' && !loadingContent && ( */}
      {status === 'loading' && !hideLoading && loadingContent}
      {status === 'loading' && !hideLoading && !loadingContent && (
        <div className="absolute inset-0 flex items-center justify-center text-gray-500 pointer-events-none">3D 에셋을 불러오는 중...</div>
      )}
      {status === 'error' && (
        <div className="absolute inset-0 flex items-center justify-center text-red-500 pointer-events-none">3D 에셋을 불러올 수 없습니다.</div>
      )}
    </div>
  );
};

export default ModelViewer;
